export default window.location.origin + '/'
// export default 'http://chinapro.kg/'
